import { useDisclosure } from '@chakra-ui/hooks';
import { Button, Flex, Link } from '@chakra-ui/react';
import { useResource } from 'datx-jsonapi-react';
import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { SpeakerShareModal } from '@/components/ui/features/speakers/SpeakerShare/SpeakerShareModal';
import { SlugIdParam, useQueryParams } from '@/hooks/useQueryParams';
import useSession from '@/hooks/useSession';
import { queryThinProfile } from '@/queries/thin-profiles';

export const ActionButtons: FC = () => {
  const { thinProfile } = useSession();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { t } = useTranslation();

  const { id } = useQueryParams<{ id: string }>({
    id: SlugIdParam,
  });

  const { data: profile } = useResource(queryThinProfile(id));

  const isMyProfile = id === thinProfile?.id;

  return (
    <Fragment>
      <Flex mt={{ base: 4, lg: 0 }} flexDirection={{ base: 'row', lg: 'column' }} gap={4}>
        <Button
          onClick={onOpen}
          alignSelf="flex-start"
          borderWidth="1px"
          borderColor="gray.200"
          colorScheme="white"
          size="sm"
        >
          share profile
        </Button>
        {isMyProfile && (
          <Link href="/my-account/profile">
            <Button alignSelf="flex-start" w="100%" colorScheme="black" size="sm">
              {t('publicSpeakerPage.editProfileButtonLabel')}
            </Button>
          </Link>
        )}
      </Flex>
      <SpeakerShareModal profile={profile} isOpen={isOpen} onClose={onClose} />
    </Fragment>
  );
};
